import { History, Plus } from "lucide-react";
import { IconButton } from "../primitives/IconButton.js";
import { COLORS, SPACE, TYPE } from "../theme/index.js";
import type { PageContext } from "./PageContextProvider.js";
import type { ChatAssistant } from "./types.js";

interface ChatHeaderProps {
  assistant: ChatAssistant;
  pageContext?: PageContext | null;
  showHistory: boolean;
  onToggleHistory: () => void;
  onNewConversation: () => void;
}

const ASSISTANT_LABELS: Record<ChatAssistant, string> = {
  jared: "Jared",
  russ: "Russ",
  richard: "Richard",
};

export function ChatHeader({
  assistant,
  pageContext,
  showHistory,
  onToggleHistory,
  onNewConversation,
}: ChatHeaderProps) {
  const pageLabel = pageContext?.pageTitle ?? pageContext?.page ?? null;
  const selectedLabel = pageContext?.selected?.label ?? null;

  return (
    <div
      style={{
        padding: `${SPACE[3]}px ${SPACE[4]}px`,
        borderBottom: `1px solid ${COLORS.border}`,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: SPACE[2],
        flexShrink: 0,
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 2, overflow: "hidden" }}>
        <span
          style={{
            fontSize: TYPE.size.sm,
            fontWeight: TYPE.weight.semibold,
            color: COLORS.text,
          }}
        >
          {ASSISTANT_LABELS[assistant]}
        </span>
        {(selectedLabel ?? pageLabel) && (
          <span
            style={{
              fontSize: TYPE.size.xs,
              color: COLORS.brandText,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={selectedLabel ?? pageLabel ?? ""}
          >
            {selectedLabel ?? pageLabel}
          </span>
        )}
      </div>
      <div style={{ display: "flex", gap: SPACE[1], flexShrink: 0 }}>
        <IconButton onClick={onNewConversation} aria-label="New conversation">
          <Plus size={15} />
        </IconButton>
        <IconButton
          onClick={onToggleHistory}
          aria-label={showHistory ? "Hide history" : "Show history"}
        >
          <History size={15} />
        </IconButton>
      </div>
    </div>
  );
}
